const sha384 = require('crypto-js/sha384');
const sha256 = require('js-sha256');
const Hashids = require('hashids/cjs');
const JSEncrypt = require('jsencrypt').default;
const api_key = 'N2IwN5ExYjM4nDdj';

//const key = 'Vega@123';

const publicKey = '-----BEGIN PUBLIC KEY-----\n'+
'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsok/Tbsqoh7NVH8eAZJ6\n'+
'D/rTyigtaiVXxfUbeQd1d7Z4GCBiJ936Zl4WHpZI0bT2hZM1Vb8nL2uS3+pTnFm0\n'+
'Ao5uFgIn0kJXxKLcCcwVSnFyvTQoQwCgIeknS3uHLWfvfPx30rVEXjVhM57DrdAp\n'+
'2CdvSq718pQXBGL6DzW5EMYgvwjKePEK7mVVPzqnpJeFfTw8dgQolUuEETZ5tYNs\n'+
'sbjGVRp5f+K8C2kxuY1aR1EECD7OnmKOuX5OKJxR9/SZAi1fKLz2nYxbjLPvLPo5\n'+
'8uWQoaq29cIF2U6SFGGw95M53hbNnXhI7KN8cfSOezgcOljIUnKgtqJYzUAMbvDE\n'+
'+QIDAQAB\n'+
'-----END PUBLIC KEY-----\n'

const privateKey = '-----BEGIN RSA PRIVATE KEY-----\n'+
'MIIEowIBAAKCAQEAsok/Tbsqoh7NVH8eAZJ6D/rTyigtaiVXxfUbeQd1d7Z4GCBi\n'+
'J936Zl4WHpZI0bT2hZM1Vb8nL2uS3+pTnFm0Ao5uFgIn0kJXxKLcCcwVSnFyvTQo\n'+
'QwCgIeknS3uHLWfvfPx30rVEXjVhM57DrdAp2CdvSq718pQXBGL6DzW5EMYgvwjK\n'+
'ePEK7mVVPzqnpJeFfTw8dgQolUuEETZ5tYNssbjGVRp5f+K8C2kxuY1aR1EECD7O\n'+
'nmKOuX5OKJxR9/SZAi1fKLz2nYxbjLPvLPo58uWQoaq29cIF2U6SFGGw95M53hbN\n'+
'nXhI7KN8cfSOezgcOljIUnKgtqJYzUAMbvDE+QIDAQABAoIBAA6ZWHrTtj3BhQrG\n'+
'xj5cquyJly3tsSD/4riGPXPdH0blvdZDN6OI7EPYp7hik5vKT2pGylKzqdGf20fC\n'+
'Eoozb5vR58CW9oij8idbJeELNiZ7NmWwUSaBc5aySQtME5ar7BJtVqL9PZTyins9\n'+
'HUUmQ3Wwa9JQkj3+zA8IxOfffb2YQvelIW5Pwu97VhFAB5hRHNXV1Jst/QP13xW3\n'+
'wSmzSkppBsteFOxVe36CEuCMVVp3ZCZSGc8xddGTI81Bkftgu/gpcdMnqALQwNY+\n'+
'O+XJXbW4g1QnwmVABei7od+s9sxXoqjW7HssXWIC5U7ZrHh2NZjcp8zqicbZUXO3\n'+
'pNnEEl0CgYEA2NRtFwjq0Prhd8RAFLvZtRxRcuUmnyoVii+YplDVJD7LVrl82NO5\n'+
'tv3+9gKcDuaG7yTsInYjQmVZVnlWmAACMyKCWPcO1m9dcJINF9HnpSOKPDrR1gxG\n'+
'dDkxw6T2ys3Ken69DehCLub8Bm1ppmqjrBamC1VM323FG6B0BYgP8ysCgYEA0snh\n'+
'iYWnrXKeTbZN/OT7SW42k9LzZ/tvJ53vFqHB0keuLbbNhvPLx9v+WZbIgOPh/Cgl\n'+
'z2XDJKFLjDsT5A51zALa17ueBO3M6QVNExFBUxL9E7BosCNoZ8pc+v1yIzLjNkwe\n'+
'f6S87hp39lcjU1mWfUXXfVTuyUqgjnpe/QqpZmsCgYBUukVaj/B58t7x1u0XbQQ4\n'+
'YjVtiR+baG18Tvb+Xm27ORJp9BdV/v3+BKiBZymmJOyrPClNmg5THplXUhjFUpOJ\n'+
'eb2nl/rjTiccGuYk3a//9rBIss9WLfvF5KeOhMKvItUxIp8rdQuPmlD3DgAPuHH2\n'+
'h+8gVJeyYwl3ry5HDxD0ewKBgHGHrmQFirROwZiVkhedtQJtzBN+UP82Wz35QGbu\n'+
'JJh/Zv7UMIp5EM7KXIogPkm9c1/+t66m3p4CCdCzmRkB+Mwy1W/Qa2G4Ot9erY6R\n'+
'gp+d4JUUNK55w6fzRHUiwLDYnawG/348Wk3cD7SsZihkXjuGvHOSpTHhceyLWFHt\n'+
'xiOVAoGBAK72cuncYdK0nXdwTL+0z0TeReDwvn6hstLeEdxDZfMjknSmr5KV9Wdy\n'+
'GAeo6wIAZhiXuCHWpYCWuIPpIdDslGy3RzSsQmkE/iYoNWpKXmSLTNVDWUJSLXVT\n'+
'8OVVKccDTP+6K5olxNYKgR1DfgMLN3kIlk0aLYh2ywCubG8MN0gN\n'+
'-----END RSA PRIVATE KEY-----\n'

// $hashGen = hash("sha256", $api_key.$key.$time.$msisdn);
//$hashGen = hash("sha256", $api_key.$key.$time.$msisdn.$otp);

//api_key = "N2IwN5ExYjM4nDdj"
// key = Vega@123

export function encryptRSA(content_hash) {
    //content_hash = 'abc'
    var encrypt = new JSEncrypt();
    encrypt.setPrivateKey(privateKey);
    //var encrypted = encrypt.encrypt(content_hash);
    //console.log(content_hash)
    var encrypted = encrypt.sign(content_hash, sha384, "sha384");

    return encrypted;
}

export function decryptRSA(content_hash) {
    var verify = new JSEncrypt();
    verify.setPublicKey(publicKey);
    var verified = verify.verify('abc', content_hash, sha384);
    return verified;
    // var decrypt = new JSEncrypt();
    // decrypt.setPrivateKey(privateKey);
    // var uncrypted = decrypt.decrypt(encrypted);
    // return uncrypted;
}

export function genHashOtp(key ,msisdn) {
    let date = new Date()
    let time = date.getTime().toString().substring(0,8);
    return sha256(api_key + key + time + msisdn)
}

export function genHashPass(key ,msisdn, password) {
    let date = new Date()
    let time = date.getTime().toString().substring(0,8);
    return sha256(api_key + key + time + msisdn + password)
}

//$api_key.$key.$time.$msisdn.$otp.$password;
export function genHashVerify(key ,msisdn = null, otp = null, password = null) {
    let date = new Date()
    let time = date.getTime().toString().substring(0,8);
    // if(!password){

    // }
    let hash = api_key + key + time

    if(msisdn != null){
        hash += msisdn
    }

    if(otp != null){
        hash += otp
    }

    if(password != null){
        hash += password
    }
    //console.log(api_key + key + time + msisdn + otp + password)
    return sha256(hash)
    //return sha256('Vega@123-N2IwN5ExYjM4nDdj')
}

export function genHashNotify(msisdn) {
    //let date = new Date()
    //let time = date.getTime().toString().substring(0,8);
    return sha256( msisdn + api_key)
    //return sha256('Vega@123-N2IwN5ExYjM4nDdj')
}

export function genHashUId(msisdn) {

    const hashids = new Hashids('vlick_vegacorp', 10, 'abcdefghij1234567890') // all lowercase
    console.log(hashids.encode(msisdn)) // mdfphx
    return hashids.encode(msisdn)
}